<template>
  <!-- Table Container Card -->
  <div>
    <div class="col-6 d-flex align-items-center justify-content-lg-start">
      <Button
        v-if="showBackButton"
        :label="$t('List page')"
        size="md"
        icon="ArrowLeftIcon"
        show-icon
        class="mb-1"
        @click="backNavigationAction"
      />
    </div>
    <b-card>
      <validation-observer ref="configurationsRules">
        <b-form>
          <div class="m-2">

            <b-row>
              <b-col
                v-if="actionType === 'edit'"
                md="6"
              >
                <InputField
                  id="edit-permission"
                  v-model="description"
                  :label="$t('Permission Name')"
                  type="text"
                  readonly
                />
              </b-col>

              <b-col
                v-if="actionType === 'save'"
                md="6"
              >
                <SelectField
                  id="permissions"
                  v-model="approvalConfigurationsFormData.permissionId"
                  :label="$t('Permissions')"
                  :placeholder="$t('Select')"
                  :options="permissionOptions"
                  item="label"
                  :reduce="option => option.value"
                  :error-name="$t('Permission')"
                  rules="required"
                  :set-selected="setPostingApproval"
                  :loading="isLoadingPermissions"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="roles"
                  v-model="userId"
                  :label="$t('Roles')"
                  :placeholder="$t('Select')"
                  :options="roleOptions"
                  item="label"
                  :reduce="option => option.value"
                  :set-selected="fetchUsers"
                  :loading="isLoadingUsers"
                />
              </b-col>
            </b-row>

          </div>

          <div v-if="users.length">

            <b-row class="mb-3">
              <!-- Per Page -->
              <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <TableEntries
                  v-model="perPage"
                  :options="perPageOptions"
                />

              </b-col>

              <!-- Search -->
              <b-col
                cols="12"
                md="6"
              >
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    v-model="filter"
                    class="d-inline-block mr-1"
                    :placeholder="$t('Search...')"
                    type="search"
                  />
                </div>
              </b-col>
            </b-row>

            <b-table
              ref="configurationRef"
              :busy="isBusy"
              :per-page="perPage"
              :current-page="currentPage"
              :items="users"
              responsive
              :fields="translatedTableHeaders"
              :filter="filter"
              :filter-included-fields="filterOn"
              filter-debounce="100"
              primary-key="id"
              show-empty
              :empty-text="$t('No records available')"
              class="position-relative"
              @filtered="onFiltered"
            >
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner
                    class="align-middle"
                    variant="primary"
                  />
                </div>
              </template>
              <template #cell(SN)="data">
                {{ getOverallIndex(data.index) }}
              </template>

              <template #cell(select)="data">
                <b-form-group class="mt-2">
                  <b-form-checkbox
                    v-model="data.item.select"
                  />
                </b-form-group>
              </template>
              <!-- Column: Actions -->
              <template #cell(actions)="data">

                <div class="text-nowrap">
                  <!-- Dropdown -->
                  <Button
                    :label="$t('Add Reviewer')"
                    size="sm"
                    :disabled="!data.item.select"
                    @click="onAddReviewer(data.item)"
                  />
                </div>
              </template>
            </b-table>

            <TablePagination
              v-model="currentPage"
              :from="from"
              :to="to"
              :total-rows="totalEntries"
              :per-page="perPage"
            />
          </div>

          <b-card v-if="approvalConfigurationsFormData.userMappings.length">
            <p> {{ $t('Assign Approval Level') }} </p>

            <b-row
              v-for="(item, index) in approvalConfigurationsFormData.userMappings"
              :id="item.id"
              :key="item.id"
              ref="configurationRef"
            >
              <b-col :md="isPostingsPermission ? 2 : 3">
                <InputField
                  id="level"
                  v-model.number="item.name"
                  :label="$t('User')"
                  type="text"
                  :error-name="$t('Level')"
                  rules="required"
                  readonly
                />
                <input
                  type="hidden"
                  :value="item.userId"
                >
              </b-col>

              <b-col :md="isPostingsPermission ? 2 : 3">
                <SelectField
                  id="permissions"
                  v-model="item.level"
                  :label="$t('Level')"
                  :placeholder="$t('Select')"
                  :options="levelOptions"
                  item="label"
                  :reduce="option => option"
                  :set-selected="updateDescription"
                />
              </b-col>

              <b-col :md="isPostingsPermission ? 2 : 3">
                <InputField
                  id="description"
                  v-model="item.description"
                  :label="$t('Description')"
                  type="text"
                  :error-name="$t('description')"
                  rules="required"
                />
              </b-col>
              <b-col
                v-if="isPostingsPermission"
                md="2"
              >
                <InputNumberField
                  id="min-amount"
                  v-model="item.minAmount"
                  :label="$t('Minimum Amount')"
                  :error-name-="$t('Min Amount')"
                  rules="required|integer|amount:@maxFee|positive"
                />
              </b-col>

              <b-col
                v-if="isPostingsPermission"
                md="2"
              >
                <InputNumberField
                  id="max-amount"
                  v-model="item.maxAmount"
                  :label="$t('Maximum Amount')"
                  :error-name-="$t('Max Amount')"
                  rules="required|integer|positive"
                  vid="maxFee"
                />
              </b-col>

              <b-col
                md="2"
                class="mt-2"
              >
                <!-- Remove Button -->

                <feather-icon
                  v-if="actionType !== 'view'"
                  v-b-tooltip.hover.bottom="$t('Remove')"
                  icon="XIcon"
                  class="mr-25 cursor-pointer text-danger"
                  @click="onRemoveReviewer(index)"
                />

              </b-col>
            </b-row>

            <div class="text-center mt-5">
              <Button
                :label="$t('Save')"
                :loading="isLoading"
                :disabled="isDisabled"
                size="lg"
                @click="handleSubmit"
              />
            </div>
          </b-card>
        </b-form>
      </validation-observer>

      <FullScreenSpinner :show="showSpinner" />
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BTable, BSpinner, BForm, VBTooltip, BFormGroup, BFormCheckbox, BFormInput,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import { required, minPhoneVal, maxPhoneVal } from '@validations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import { permissionMixin } from '@core/mixins/permission'
import { heightTransition } from '@core/mixins/ui/transition'
import { ValidationObserver } from 'vee-validate'
import { toastAlert } from '@core/mixins/toast'
import { toKobo, toBalance } from '@/helpers/formatAmount'
import TablePagination from '@/views/components/table/TablePagination.vue'
import TableEntries from '@/views/components/table/TableEntries.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import InputField from '../../../forms/InputField.vue'
import SelectField from '../../../forms/SelectField.vue'
import InputNumberField from '../../../forms/InputNumberField.vue'
import Button from '../../../components/button/Button.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    TablePagination,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    TableEntries,
    BForm,
    SelectField,
    InputField,
    Button,
    FullScreenSpinner,
    InputNumberField,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin, heightTransition, toastAlert],
  data() {
    return {
      hasSelectedAllRow: false,
      isLoading: false,
      isDisabled: false,
      isReadonly: false,
      isReviewer: false,
      isEditable: false,
      isFullName: false,
      showSpinner: false,
      showBackButton: false,
      isLoadingPermissions: false,
      isPostingsPermission: false,
      isLoadingUsers: false,
      sortBy: 'name',
      searchQuery: '',
      required,
      minPhoneVal,
      maxPhoneVal,
      modalTitle: this.$t('Create Account Officer'),
      sortDesc: false,
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'select', label: 'Select' },
        { key: 'id', sortable: true, label: 'User ID' },
        { key: 'fullName', sortable: true, label: 'Full Name' },
        { key: 'branch', sortable: true, label: 'Branch' },
        { key: 'scopeLimit', sortable: true, label: 'User Scope' },
        { key: 'actions', label: 'Actions' },
      ],
      actionType: 'save',
      setupType: 'setup',
      totalRows: 1,
      filterOn: [],
      filter: null,
      description: '',
      buttonLabel: this.$t('Save'),
      approvalConfigurationsFormData: {
        permissionId: '',
        userMappings: [],
      },
      userId: '',
      roleOptions: [],
      permissionOptions: [],
      permissions: [],
      allPermissions: [],
      selectedUsers: [],
      users: [],
      levelOptions: [],
      prevRoute: null,
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // eslint-disable-next-line no-param-reassign
      vm.prevRoute = from
    })
  },
  // computed: {
  //   totalEntries() {
  //     return this.users.length
  //   },
  //   from() {
  //     return (this.currentPage * this.perPage) - (this.perPage - 1)
  //   },
  //   to() {
  //     return Math.min(this.from + this.perPage - 1, this.totalEntries)
  //   },
  // },
  computed: {
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
  },
  watch: {
    searchQuery(newValue) {
      this.searchQuery = newValue
      this.filterUsers(newValue)
    },
  },
  mounted() {
    const { type } = this.$route.params
    this.setupType = type
    this.fetchPermissions()
    this.fetchRoles()
    this.fetchApprovalConfiguration()
  },
  methods: {
    ...mapActions({
      getApprovalConfiguration: 'operations/getApprovalConfiguration',
      getUserByRoleId: 'admin/getUserByRoleId',
      getPermissions: 'admin/getAllPermission',
      getRoles: 'admin/getRoles',
      createApprovalConfiguration: 'operations/createApprovalConfiguration',
    }),
    async fetchPermissions() {
      try {
        this.isLoadingUsers = true
        const response = await this.getPermissions({ permission: this.actionType === 'save' ? 'CREATE_APPROVAL_SETUP' : 'MODIFY_APPROVAL_SETUP' })
        const { status, data } = response
        if (status === 200) {
          if (this.setupType === 'setup') {
            this.permissionOptions = data.data.filter(item => item.isApprovable && !item.hasApprovalConfigured && !item.isPostingsPermission).map(item => ({
              label: item.description,
              value: item.id,
            })).sort((a, b) => a.label - b.label)
          } else {
            this.permissionOptions = data.data.filter(item => item.isApprovable && !item.hasApprovalConfigured && item.isPostingsPermission).map(item => ({
              label: item.description,
              value: item.id,
            })).sort((a, b) => a.label - b.label)
          }

          // this.allPermissions = data.data.filter(item => item.isApprovable && !item.hasApprovalConfigured)
          this.allPermissions = data.data.filter(item => item.isApprovable)
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isLoadingUsers = false
        this.isBusy = false
      }
    },
    async fetchRoles() {
      try {
        this.isLoadingPermissions = true
        const response = await this.getRoles({
          search: '',
          page: 0,
          limit: 1000,
          permission: this.actionType === 'save' ? 'CREATE_APPROVAL_SETUP' : 'MODIFY_APPROVAL_SETUP',
        })
        const { status, data } = response
        if (status === 200) {
          this.roleOptions = data.data.map(item => ({
            value: item.id,
            label: item.name,
          }))
          // eslint-disable-next-line no-nested-ternary
          this.roleOptions.sort((a, b) => (a.label === b.label ? 0 : a.label < b.label ? -1 : 1))
          this.totalCount = data.totalItems
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isLoadingPermissions = false
      }
    },

    updateDescription(item) {
      const match = this.approvalConfigurationsFormData.userMappings.find(
        val => val.level === item.level,
      )
      if (match) match.description = ''
    },
    async fetchUsers(id) {
      try {
        this.showSpinner = true
        // this.approvalConfigurationsFormData.userMappings = []
        const response = await this.getUserByRoleId({ id, status: 'Active', permission: this.actionType === 'save' ? 'CREATE_APPROVAL_SETUP' : 'MODIFY_APPROVAL_SETUP' })
        const { status, data } = response

        if (status === 200) {
          if (data.data.length) {
            this.users = data.data.map(item => ({
              ...item,
              select: false,
              id: item.email,
              fullName: `${item.lastname} ${item.firstname} ${item?.othernames ?? ''}`,
            // eslint-disable-next-line no-nested-ternary
            })).sort((a, b) => (a.fullName === b.fullName ? 0 : a.fullName < b.fullName ? -1 : 1))
            this.totalCount = this.users.length
          } else {
            this.alertError({ text: this.$t('No user assigned to this role') })
            this.users = []
            this.totalCount = 0
          }

          this.showSpinner = false
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    // onRowSelected(items) {
    //   items.select = true
    // },
    setPostingApproval(value) {
      const postingApprovals = this.allPermissions.find(item => item.id === value)
      this.isPostingsPermission = postingApprovals.isPostingsPermission
    },
    onAddReviewer(item) {
      try {
        this.showSpinner = true
        this.selectedUsers.push(item)
        const selectedUserIndex = this.users.findIndex(items => item.id === items.id)
        this.users.splice(selectedUserIndex, 1)
        // this.approvalConfigurationsFormData.userMappings = this.selectedUsers.map(items => ({
        //   name: items.fullName,
        //   userId: items.id,
        //   level: 1,
        // }))

        this.approvalConfigurationsFormData.userMappings.push({
          name: item.fullName,
          userId: item.id,
          level: 1,
          description: '',
        })
        this.levelOptions = Array.from({ length: this.selectedUsers.length }, (_, i) => i + 1)
        // this.alertSuccess({ text: 'Your request to add User to reviewer was successful' })
        this.showSpinner = false

        // this.confirm(updateAddReviewer, { title: '', text: 'Are you sure you want to add this User to reviewer?' })
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    onRemoveReviewer(index) {
      try {
        const removedItem = this.approvalConfigurationsFormData.userMappings.splice(index, 1)
        const selectedUser = this.selectedUsers.find(item => item.id === removedItem[0].userId)
        const selectedUserIndex = this.selectedUsers.findIndex(item => item.id === removedItem[0].userId)
        this.selectedUsers.splice(selectedUserIndex, 1)
        this.levelOptions = Array.from({ length: this.selectedUsers.length }, (_, i) => i + 1).sort((a, b) => a - b)
        this.users.push(selectedUser)

        // this.confirm(updateRemoveReviewer, { title: '', text: 'Are you sure you want to remove this User from reviewer?' })
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    onSelectAll() {
      const item = !this.hasSelectedAllRow
      // eslint-disable-next-line no-unused-expressions
      item === true ? this.$refs.configurationRef.selectAllRows() : this.this.$refs.selectableTable.clearSelected()
    },
    async approvalConfigurationAction() {
      try {
        this.isLoading = true
        this.showSpinner = true
        const formData = this.approvalConfigurationsFormData.userMappings.map(item => ({
          userId: item.userId,
          level: item.level,
          description: item.description,
          minAmount: this.setupType === 'setup' ? 0 : toKobo(item.minAmount),
          maxAmount: this.setupType === 'setup' ? 0 : toKobo(item.maxAmount),
        }))

        const response = await this.createApprovalConfiguration({
          ...this.approvalConfigurationsFormData,
          userMappings: formData,
        })

        const { status } = response
        if (status === 200) {
          const yourRequest = this.$t('Your request to')
          const successText = this.$t('setup configuration was successful')
          this.alertSuccess({ text: `${yourRequest} ${this.actionType === 'edit' ? this.$t('Edit') : this.$t('Save')} ${successText}` })
          if (this.setupType === 'setup') {
            this.$router.push({ name: 'setup' })
          } else {
            this.$router.push({ name: 'posting-approvals' })
          }
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.showSpinner = false
      }
    },
    handleSubmit() {
      this.$refs.configurationsRules.validate().then(success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to')
          const setupText = this.$t('this setup configuration?')
          this.confirm(this.approvalConfigurationAction, { text: `${areYouSure} ${this.actionType === 'edit' ? this.$t('Edit') : this.$t('Save')} ${setupText}` })
        }
      })
    },
    async fetchApprovalConfiguration() {
      try {
        this.showSpinner = true
        this.showBackButton = true
        const { id } = this.$route.params
        if (id !== undefined) {
          this.actionType = 'edit'
          const response = await this.getApprovalConfiguration({ id })
          const { status, data } = response

          if (status === 200 && data.userMappings.length) {
            const userMappings = data.userMappings.map(items => {
              if (items.user !== null) {
                return {
                  fullName: `${items.user.lastname} ${items.user.firstname} ${items.user.othernames === null ? '' : items.user.othernames}`,
                  userId: items.user.id,
                  level: items.level,
                  accessLevel: items.user.accessLevel,
                  address: items.user.address,
                  branch: items.user.branch,
                  branchID: items.user.branchID,
                  canApprove: items.user.canApprove,
                  dateCreated: items.user.dateCreated,
                  dateLastModified: items.user.dateLastModified,
                  designation: items.user.designation,
                  email: items.user.email,
                  employeeNumber: items.user.employeeNumber,
                  firstname: items.user.firstname,
                  forceChangeOfPassword: items.user.forceChangeOfPassword,
                  hasPermissionExclusion: items.user.hasPermissionExclusion,
                  id: items.user.id,
                  lastLoginDate: items.user.lastLoginDate,
                  lastname: items.user.lastname,
                  notes: items.user.notes,
                  othernames: items.user.othernames,
                  permissions: items.user.permissions,
                  phoneNumber: items.user.phoneNumber,
                  role: items.user.role,
                  roleID: items.user.roleID,
                  scopeLimit: items.user.scopeLimit,
                  securityQuestion: items.user.securityQuestion,
                  status: items.user.status,
                  username: items.user.username,
                }
              }
              return {}
            }).sort((a, b) => a.level - b.level)

            this.approvalConfigurationsFormData.permissionId = data.permission.id
            this.description = data.permission.description
            this.userId = data.userMappings[0].user.roleID
            await this.fetchUsers(data.userMappings[0].user.roleID)

            const postingApprovals = this.allPermissions.find(item => item.description === data.permission.description)
            this.setPostingApproval(postingApprovals.id)

            this.selectedUsers = this.users.filter(el => userMappings.some(f => f.username === el.username))

            this.users = this.users.filter(el => userMappings.every(f => f.username !== el.username))

            this.approvalConfigurationsFormData.userMappings = data.userMappings.map(items => ({
              name: `${items.user.lastname} ${items.user.firstname} ${items.user.othernames === null ? '' : items.user.othernames}`,
              userId: items.user.email,
              level: items.level,
              description: items.description,
              minAmount: items.minAmount ? toBalance(items.minAmount) : items.minAmount.toString(),
              maxAmount: items.maxAmount ? toBalance(items.maxAmount) : items.maxAmount.toString(),
            })).sort((a, b) => a.level - b.level)
            this.levelOptions = Array.from({ length: this.selectedUsers.length }, (_, i) => i + 1)
          }

          this.showSpinner = false
        }
      } catch (error) {
        this.handleError({ text: error })
        this.showSpinner = false
      } finally {
        this.showSpinner = false
      }
    },
    filterUsers(query) {
      this.users.filter(item => {
        // debugger
        if (query.toLowerCase() === item.fullName.toLowerCase()) {
          return item
        }
        return ''
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalCount = filteredItems.length
      this.currentPage = 1
    },
    backNavigationAction() {
      this.showBackButton = true
      this.$router.push({
        name: this.prevRoute.name,
      })
    },
  },
}
</script>

<style scoped>
  .table-responsive {
    padding-bottom: 50px !important;
    margin-bottom: 0;
  }
</style>
